import { render, staticRenderFns } from "./modalgoaltype.vue?vue&type=template&id=5be0b438"
import script from "./modalgoaltype.vue?vue&type=script&lang=js"
export * from "./modalgoaltype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports